import { render, staticRenderFns } from "./CountedServiceTypeUpdate.vue?vue&type=template&id=165d53dc&"
import script from "./CountedServiceTypeUpdate.vue?vue&type=script&lang=js&"
export * from "./CountedServiceTypeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports